import { render, staticRenderFns } from "./FreeText.vue?vue&type=template&id=8171c6f8&scoped=true&lang=pug"
import script from "./FreeText.vue?vue&type=script&lang=ts"
export * from "./FreeText.vue?vue&type=script&lang=ts"
import style0 from "./FreeText.vue?vue&type=style&index=0&id=8171c6f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8171c6f8",
  null
  
)

export default component.exports